import { useEffect, useState } from 'react';
import { loadPilotLearnerRecord, PILOT_LEARNER_UPDATED_EVENT } from './learnerRecordStore';

export function usePilotLearnerRecord() {
  const [record, setRecord] = useState(loadPilotLearnerRecord);

  useEffect(() => {
    const reload = () => setRecord(loadPilotLearnerRecord());
    window.addEventListener('storage', reload);
    window.addEventListener(PILOT_LEARNER_UPDATED_EVENT, reload);
    return () => {
      window.removeEventListener('storage', reload);
      window.removeEventListener(PILOT_LEARNER_UPDATED_EVENT, reload);
    };
  }, []);

  return record;
}
